import React, { Fragment, useState, useCallback } from 'react';
import CancelOffersContainer from './CancelOffersContainer';
import CancelOffersHeaderLinks from './CancelOffersHeaderLinks';
import Header from './header/Header';
import PropTypes from 'prop-types';
import { areas } from 'constants/areas';
import Portal from 'utils/portal/Portal';
import { withAreaGetter } from 'providers/AreasConsumers';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_CANCEL_OFFERS } from 'constants/rightsCodes';

const Route = props => {
  const { getElemByAreaKey } = props;
  const [disabledSave, setDisabledSave] = useState(true);
  const [onSave, setOnSave] = useState({ fn: () => {} });

  const onSaveFnChanged = useCallback((fn, disabledSave) => {
    setOnSave({ fn });
    setDisabledSave(disabledSave);
  }, []);

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header></Header>
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_CANCEL_OFFERS} withForbiddenPage={false}>
          <CancelOffersHeaderLinks disabledSave={disabledSave} onSave={onSave.fn} />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_CANCEL_OFFERS}>
        <CancelOffersContainer onSaveFnChanged={onSaveFnChanged} />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
